import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatPaginator,
  PageEvent,
} from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { SRBetStatusList } from "../../../_constants/bet_filters";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";

@Component({
  selector: 'app-sr-bets-settlement',
  templateUrl: './sr-bets-settlement.component.html',
  styleUrls: ['./sr-bets-settlement.component.scss']
})
export class SrBetsSettlementComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  selectedBetId = "";
  length: any = 0;
  displayTableColumns = [
    "Date",
    "UserName",
    "Bet Id",
    "MarketName",
    "BetType",
    "Odds",
    "Stake",
    "SessionOutcome",
    "Status",
  ];
  bets = [];
  markets = [];
  sportId = "";
  eventId = "";
  eventName = "";
  startDate: null;
  endDate: null;
  openDate = 0;
  sportName: string = "";
  providerId: string = "";
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  selectedMarket = "";
  selectedUserName = "";
  userNamefilter: boolean = false;
  betStatusList = [].concat(SRBetStatusList);
  selectedBetStatus = new FormControl([this.betStatusList[1]]);
  statusSettings: any = {};
  selectedBets = [];
  count = 0;
  selectAllChecked = false;
  isDisabled = true;
  uniStatus = "";
  uniMarket = "";
  // Providers whose event markets are listed for the market drop down filter.
  marketFilterProviders = ["Tommy", "RX", "Dream", "BetFair"];
  marketsList = [];
  selectedMarketOption = new FormControl([]);
  marketSettings: any = {};
  betTimeRange: any = null;
  ranges: any = {};

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private activetedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.activetedRoute.queryParams.subscribe((params) => {
      this.providerId = params["providerId"];
      this.sportId = params["sportId"];
      this.eventId = params["eventId"];
      this.eventName = params["eventName"];
      this.sportName = params["sportName"];
      this.openDate = parseInt(params["openDate"]);
      this.startDate = params["startDate"];
      this.endDate = params["endDate"];
    });
    this.statusSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.marketSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      maxHeight: 250,
      searchPlaceholderText: "Search market",
      noDataAvailablePlaceholderText: "No markets for this event",
    };
    this.refreshRanges();
    if (this.showMarketFilter) {
      this.getEventMarkets();
    }
    this.getEventBets();
  }

  // Market drop down is only listed for the providers we settle market wise.
  get showMarketFilter(): boolean {
    return this.marketFilterProviders.some(
      (provider) =>
        provider.toLowerCase() === (this.providerId || "").toLowerCase()
    );
  }

  getEventMarkets() {
    try {
      this.appService
        .listEventMarkets({
          providerId: this.providerId,
          sportId: this.sportId,
          eventId: this.eventId,
        })
        .subscribe((response) => {
          if (response.status === "RS_OK") {
            this.marketsList = (response.markets || [])
              .map((market) => ({
                id: market.marketId,
                name: market.marketType
                  ? market.marketName + " (" + market.marketType + ")"
                  : market.marketName,
              }))
              .sort((a, b) => a.name.localeCompare(b.name));
          } else if (response.errorDescription === "Invalid Token!") {
            this.appService.openErrorBar(response.errorDescription);
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  // The picked market wins over the typed market id, so the drop down stays the
  // primary filter for the providers that have one.
  getMarketFilter(): string {
    const picked = this.selectedMarketOption.value;
    if (this.showMarketFilter && picked && picked.length) {
      return picked[0].id;
    }
    return this.selectedMarket ? this.selectedMarket : "";
  }

  getBetTimeFilter() {
    const range = { startTime: 0, endTime: 0 };
    if (this.betTimeRange && this.betTimeRange.startDate) {
      range.startTime = Math.floor(
        moment(this.betTimeRange.startDate).valueOf() / 1000
      );
    }
    if (this.betTimeRange && this.betTimeRange.endDate) {
      range.endTime = Math.floor(
        moment(this.betTimeRange.endDate).valueOf() / 1000
      );
    }
    return range;
  }

  // Rebuilt on every fetch so the relative presets stay accurate on a page that
  // is left open for a while.
  refreshRanges() {
    this.ranges = {
      "Last 15 Mins": [moment().subtract(15, "minutes"), moment()],
      "Last 30 Mins": [moment().subtract(30, "minutes"), moment()],
      "Last 1 Hour": [moment().subtract(1, "hours"), moment()],
      "Last 6 Hours": [moment().subtract(6, "hours"), moment()],
      Today: [moment().startOf("day"), moment()],
      Yesterday: [
        moment().subtract(1, "days").startOf("day"),
        moment().subtract(1, "days").endOf("day"),
      ],
    };
  }

  onBetTimeChange(event) {
    const startDate = event && event.startDate ? event.startDate : null;
    const endDate = event && event.endDate ? event.endDate : null;
    // The picker re-emits an empty range whenever it is written to, so skip the
    // refetch when it was already empty (page load, and Reset).
    const wasAlreadyEmpty = !startDate && !endDate && !this.betTimeRange;
    this.betTimeRange = startDate || endDate ? { startDate, endDate } : null;
    if (wasAlreadyEmpty) {
      return;
    }
    this.onFilterChange();
  }

  getEventBets() {
    try {
      let filters;
      this.refreshRanges();
      if (this.selectedBetId == "" || this.selectedBetId == null) {
        const betTime = this.getBetTimeFilter();
        filters = {
          providerId: this.providerId,
          sportId: this.sportId,
          eventId: this.eventId,
          marketId: this.getMarketFilter(),
          userName: this.selectedUserName ? this.selectedUserName : "",
          betId: this.selectedBetId.toLowerCase(),
          page: this.page,
          status:
            this.selectedBetStatus.value.length === 0
              ? ""
              : this.selectedBetStatus.value[0].id,
          startTime: betTime.startTime,
          endTime: betTime.endTime,
          pageSize: this.orgPageSize,
        };
      } else {
        filters = {
          providerId: this.providerId,
          sportId: this.sportId,
          eventId: this.eventId,
          betId: this.selectedBetId.toLowerCase(),
        };
      }

      this.appService.getEventBets(filters).subscribe((response) => {
        if (response.status === "RS_OK") {
          this.bets = [];
          this.clearSelection();
          if (this.page == 1) {
            this.length = response.totalCount;
          }
          this.bets = response.bets || [];
          this.count = this.bets.length;
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  userNamefill() {
    this.userNamefilter = true;
  }

  onUserNameSelection(value) {
    this.selectedUserName = value.trim();
  }

  onUserNameSelectionClear() {
    if (this.selectedUserName == "" || this.selectedUserName == null) {
      this.userNamefilter = false;
    }
    this.selectedUserName = null;
  }

  clearSelection() {
    this.selectedBets = [];
    this.selectAllChecked = false;
    this.uniStatus = "";
    this.uniMarket = "";
    this.isDisabled = true;
  }

  // Only OPEN / SETTLED bets can be acted on.
  isActionable(element) {
    return ["OPEN", "SETTLED"].includes(element.status);
  }

  // A batch has to be of one status, and OPEN batches of one market too, because
  // settle asks for a single runner / session outcome for the whole batch.
  matchesSelection(element) {
    if (!this.isActionable(element)) {
      return false;
    }
    if (this.uniStatus === "") {
      return true;
    }
    if (element.status !== this.uniStatus) {
      return false;
    }
    return this.uniMarket === "" || this.uniMarket === element.marketId;
  }

  // Bets on the current page that could join the current batch.
  selectableBets() {
    return (this.bets || []).filter((bet) => this.matchesSelection(bet));
  }

  hasActionableBets() {
    return (this.bets || []).some((bet) => this.isActionable(bet));
  }

  selectAllBets(checked: boolean) {
    if (!checked) {
      this.clearSelection();
      return;
    }
    // Anchor the batch on the first actionable row, then take everything on the
    // page that matches it.
    const anchor = (this.bets || []).find((bet) => this.isActionable(bet));
    if (!anchor) {
      this.clearSelection();
      return;
    }
    this.uniStatus = anchor.status;
    this.uniMarket = anchor.status === "OPEN" ? anchor.marketId : "";
    this.selectedBets = this.selectableBets().map((bet) => bet.transactionId);
    this.selectAllChecked = this.selectedBets.length > 0;
    this.isValid();
  }

  onCheckingBet(checked, item) {
    if (this.isActionable(item)) {
      if (checked) {
        if (this.selectedBets.length == 0) {
          this.uniStatus = item.status;
          if (item.status == "OPEN") {
            this.uniMarket = item.marketId;
          }
        }
        if (this.uniStatus === item.status) {
          this.selectedBets.push(item.transactionId);
        }
      } else {
        let index = this.selectedBets.indexOf(item.transactionId);
        if (index != -1) {
          this.selectedBets.splice(index, 1);
          if (this.selectedBets.length == 0) {
            this.uniStatus = "";
            this.uniMarket = "";
          }
        }
      }
    }
    this.selectAllChecked =
      this.selectedBets.length > 0 &&
      this.selectedBets.length === this.selectableBets().length;
    this.isValid();
  }

  disableCheckbox(element) {
    return !this.matchesSelection(element);
  }

  isValid() {
    if (this.selectedBets.length >= 1) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.getEventBets();
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getEventBets();
  }

  settleBet() {
    try {
      let dialogRef = this.dialog.open(BetSettlementModal, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          betIds: this.selectedBets,
          runners: this.bets
            .filter((bet) => bet.transactionId === this.selectedBets[0])
            .map((bet) => bet.runners),
          status: this.uniStatus,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getEventBets();
        }
      });
    } catch (err) {
      console.log(err);
      this.authenticationService.openErrorSnackBar("invalid");
    }
  }

  onBetIdSelection(value) {
    this.selectedBetId = value.trim();
  }

  onBetIdSelectionClear() {
    this.selectedBetId = "";
  }

  onMarketIdSelection(value) {
    this.selectedMarket = value.trim();
  }

  onMarketIdSelectionClear() {
    this.selectedMarket = null;
  }

  isFancy(element) {
    return (element && element.marketType) === "FANCY";
  }

  statusClass(element) {
    return "status-" + (element.status || "unknown").toLowerCase();
  }

  // Describes what the current batch is limited to, so it is obvious why the
  // other rows went un-selectable.
  selectionScope(): string {
    if (!this.uniStatus) {
      return "";
    }
    if (!this.uniMarket) {
      return this.uniStatus;
    }
    const bet = (this.bets || []).find(
      (item) => item.marketId === this.uniMarket
    );
    return this.uniStatus + " \u00b7 " + (bet ? bet.marketName : this.uniMarket);
  }

  resetFilters() {
    this.betTimeRange = null;
    this.selectedMarketOption.setValue([]);
    this.selectedBetStatus.setValue([this.betStatusList[1]]);
    this.selectedMarket = "";
    this.selectedBetId = "";
    this.selectedUserName = "";
    this.userNamefilter = false;
    this.onFilterChange();
  }

  convertopenDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  goBack() {
    this.router.navigate(["surveillance/sr_events"], {
      queryParams: {
        providerId: this.providerId,
        sportId: this.sportId,
        sportName: this.sportName,
        startDate: this.startDate,
        endDate: this.endDate,
      },
    });
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./sr-bets-settle-modal.html",
  styleUrls: ["./sr-bets-settlement.component.scss"],
})
export class BetSettlementModal {
  reason: string = "";
  isDisabled = true;
  disabledStatus = true;
  selectedRunnerName: any;
  sessionOutcome = 0;
  constructor(
    private appService: AppService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<BetRollbackModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onSelectingRunner() {
    this.isDisabled = false;
  }

  onChangeTheReason(event) {
    this.reason = event.target.value;
    if (this.reason.length > 0) {
      this.disabledStatus = false;
    } else {
      this.disabledStatus = true;
    }
  }

  onChangingSessionOutcome(sessionOutcome) {
    this.isDisabled = sessionOutcome ? false : true;
    this.sessionOutcome = sessionOutcome;
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === "e" || event.key === "-" || event.key === "+") {
      event.preventDefault();
    }
  }

  settleBet(action) {
    try {
      let dialogRef = this.dialog.open(SettlementConfirmModal, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          betIds: this.data.betIds,
          runnerId: this.selectedRunnerName
            ? this.selectedRunnerName.RunnerId
            : "",
          runnerName: this.selectedRunnerName
            ? this.selectedRunnerName.RunnerName
            : "",
          sessionOutcome: isNaN(this.sessionOutcome)
            ? 0
            : Number(this.sessionOutcome),
          action: action,
          reason: this.reason
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.dialogRef.close(true);
        }
      });
    } catch (err) {
      console.log(err);
      this.authenticationService.openErrorSnackBar("invalid");
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./settlement-confirm-modal.html",
  styleUrls: ["./sr-bets-settlement.component.scss"],
})
export class SettlementConfirmModal {
  reason: string = "";
  isDisabled = true;
  disabledStatus = true;
  selectedRunnerName: any;
  sessionOutcome = 0;
  constructor(
    private appService: AppService,
    private authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<BetRollbackModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  capitalizeFirstLetter(value) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

  settleBets() {
    if (this.data.action == "SETTLE") {
      try {
        let filters = {
          betIds: this.data.betIds,
          runnerId: this.data.runnerId ? this.data.runnerId : "",
          runnerName: this.data.runnerName ? this.data.runnerName : "",
          sessionOutcome: this.data.sessionOutcome,
        };
        this.appService.multiBetSettle(filters).subscribe((res) => {
          this.dialogRef.close(true);
          if (res.status === "RS_OK") {
            this.authenticationService.openSnackBar(res.errorDescription);
          } else {
            this.authenticationService.openErrorSnackBar(res.errorDescription);
          }
        });
      } catch (err) {
        console.log(err);
        this.authenticationService.openErrorSnackBar(err);
      }
    } else if (this.data.action == "ROLLBACK") {
      try {
        let filters = {
          betIds: this.data.betIds,
          reason: this.data.reason,
        };
        this.appService.multiBetRollback(filters).subscribe((res) => {
          this.dialogRef.close(true);
          if (res.status === "RS_OK") {
            this.authenticationService.openSnackBar(res.errorDescription);
          } else {
            this.authenticationService.openErrorSnackBar(res.errorDescription);
          }
        });
      } catch (err) {
        console.log(err);
        this.authenticationService.openErrorSnackBar(err);
      }
    } else if (this.data.action == "VOID") {
      try {
        let filters = {
          betIds: this.data.betIds,
          reason: this.data.reason,
        };
        this.appService.multiBetVoid(filters).subscribe((res) => {
          this.dialogRef.close(true);
          if (res.status === "RS_OK") {
            this.authenticationService.openSnackBar(res.errorDescription);
          } else {
            this.authenticationService.openErrorSnackBar(res.errorDescription);
          }
        });
      } catch (err) {
        console.log(err);
        this.authenticationService.openErrorSnackBar(err);
      }
    } else {
      this.dialogRef.close(true);
      this.appService.openErrorBar("Invalid Action");
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./sr-bets-void-modal.html",
  styleUrls: ["./sr-bets-settlement.component.scss"],
})
export class BetRollbackModal {
  buttonName = "Rollback"
  reason: string = "";
  disabledStatus = true;
  constructor(
    private appService: AppService,
    private authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<BetRollbackModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {  }

  onChangeTheReason(event) {
    this.reason = event.target.value;
    if (this.reason.length > 0) {
      this.disabledStatus = false;
    } else {
      this.disabledStatus = true;
    }
  }

  voidBet() {
    let filters = {
      betId : this.data.betId,
      rollbackReason : this.reason
    }
      try {
        this.appService
          .opBetRollback(filters)
          .subscribe((response) => {
            this.dialogRef.close(true);
            if (response.status === "RS_OK") {
              this.authenticationService.openSnackBar(response.errorDescription);
            } else {
              this.authenticationService.openErrorSnackBar(response.errorDescription);
            }
          });
      } catch (err) {
        console.log(err);
      }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}